/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosSearchHandlerInfo = {
    ID: AptosSearchHandlerInfo.ID;
    SRLIST: Record<string, any>;
};

export namespace AptosSearchHandlerInfo {

    export enum ID {
        ALL = 'ALL',
        BLOCK = 'BLOCK',
        TRANSACTION = 'TRANSACTION',
        ADDRESS = 'ADDRESS',
        ADDRESS_LABEL = 'ADDRESS_LABEL',
        MODULE = 'MODULE',
        COIN = 'COIN',
        COIN_HOLDER = 'COIN_HOLDER',
        FUNGIBLE_ASSET = 'FUNGIBLE_ASSET',
        TOKEN = 'TOKEN',
        COLLECTION = 'COLLECTION',
        OBJECT = 'OBJECT',
    }


}

